import { TFunction, ApiError, AuthErrors, getPropObj } from '@manigo/manigo-commons';

import { currentUserReducerName } from './actions.types';


enum SET_CURRENT_USER_VARIANT {
    LOGIN = 'LOGIN',
    GET_JWT_FROM_STORAGE = 'GET_JWT_FROM_STORAGE',
    REFRESH_SESSION = 'REFRESH_SESSION',
    DUPLICATE_TAB = 'DUPLICATE_TAB',
}

export const createChangeBusinessUserPasswordErrorMessage = (t: TFunction, error: ApiError) => {
    const handlers = [
        {
            predicate: () => error.message === AuthErrors.INVALID_CREDENTIALS,
            handler: () => (t('businessUsers:actionMessages.changePasswordInvalidOldPassword')),
        },
        {
            predicate: () => true,
            handler: () => (t('unauthorised:genericApiError')),
        },
    ];

    return handlers.filter(({ predicate }) => predicate())[0].handler();
};

const mapPermissionNameToObjectPath = (permissionName: string): string =>
    permissionName.replace(/:/g, '.');

export const selectHasPermission = (state, permissionName: string): boolean => {
    const permissions = state[currentUserReducerName]?.permissions || {};
    const path = mapPermissionNameToObjectPath(permissionName);
    return getPropObj(permissions, path) === true;
};

export default SET_CURRENT_USER_VARIANT;
